import React, { Component } from 'react';
import {
    EmailShareButton,
    FacebookShareButton,
    HatenaShareButton,
    InstapaperShareButton,
    LineShareButton,
    LinkedinShareButton,
    LivejournalShareButton,
    MailruShareButton,
    OKShareButton,
    PinterestShareButton,
    PocketShareButton,
    RedditShareButton,
    TelegramShareButton,
    TumblrShareButton,
    TwitterShareButton,
    ViberShareButton,
    VKShareButton,
    WhatsappShareButton,
    WorkplaceShareButton,
    FacebookMessengerShareButton
} from "react-share";
import {
    FacebookShareCount,
    HatenaShareCount,
    OKShareCount,
    PinterestShareCount,
    RedditShareCount,
    TumblrShareCount,
    VKShareCount
} from "react-share";
import {
    EmailIcon,
    FacebookIcon,
    FacebookMessengerIcon,
    HatenaIcon,
    InstapaperIcon,
    LineIcon,
    LinkedinIcon,
    LivejournalIcon,
    MailruIcon,
    OKIcon,
    PinterestIcon,
    PocketIcon,
    RedditIcon,
    TelegramIcon,
    TumblrIcon,
    TwitterIcon,
    ViberIcon,
    VKIcon,
    WeiboIcon,
    WhatsappIcon,
    WorkplaceIcon,
} from "react-share";
import Button from "react-bootstrap/Button";

class Movie extends Component {
    constructor() {
        super();
    }

    playClick(item) {
        this.props.playMovie(item);
    }

    downloadClick(item) {
        this.props.downloadMovie(item);
    }

    folderClick(item) {
        this.props.openFolder(item);
    }

    render() {

        let isFolder = false;
        if (this.props.mimeType && this.props.mimeType === "application/vnd.google-apps.folder") {
            isFolder = true;
        }

        let buttonTitle = 'Play';
        if (this.props.mimeType && this.props.mimeType === "image/png") {
            buttonTitle = 'View';
        }

        let url = this.props.item.webContentLink;

        let folderTitle = this.props.item.name;
        let folderIconName = 'folderc.png';
        if (folderTitle.includes("_PM") || folderTitle.includes("_AM")) {
            folderIconName = 'foldert.png';
        }
        if (folderTitle.includes("Hole")) {
            folderIconName = 'folderh.png';
        }
        if (folderTitle.includes("Gallery")) {
            folderIconName = 'folderg.png';
        }

        let scale = 0.97;

        let cname = this.props.movieListCnt > 1 ? "Movie" : "Movie";

        return (
            <div className={cname}>

                {!isFolder && <p><div className="App-title">{''}</div></p>}
                {isFolder && <p><div className="Folder-title">{this.props.title}</div></p>}
                {isFolder && <div><img width={133} height={110} src={folderIconName} onClick={this.folderClick.bind(this, this.props.item)} /></div>}
                {!isFolder &&
                    <div className="Thumbnail" onClick={this.playClick.bind(this, this.props.item)}>
                        <img className={'ThumbnailImg'} src={this.props.poster} />
                        {this.props.mimeType && this.props.mimeType === "video/mp4" && <div className="PlayIcon">
                            <img width={300 * scale} height={170 * scale} src={"playtile.png"} />
                        </div>}
                        {this.props.mimeType && this.props.mimeType === "video/quicktime" && <div className="PlayIcon">
                            <img width={300 * scale} height={170 * scale} src={"playtile.png"} />
                        </div>}
                    </div>}
                <div className="Movie-Description">
                    {!isFolder && <button className={"blueBtn"} style={{ marginLeft: 14, width: 80, height: 30, backgroundColor: '#038EFB', borderRadius: 6, borderWidth: 0, color: 'white' }} variant="outline-primary" onClick={this.playClick.bind(this, this.props.item)}>{buttonTitle}</button>}

                    {!isFolder && <EmailShareButton
                        url={url}
                    >
                        <EmailIcon size={25} round />
                    </EmailShareButton>}
                    {!isFolder && <FacebookShareButton
                        url={url}
                    >
                        <FacebookIcon size={25} round />
                    </FacebookShareButton>}
                    {!isFolder && <WhatsappShareButton
                        url={url}
                    >
                        <WhatsappIcon size={25} round />
                    </WhatsappShareButton>}

                    {!isFolder &&
                        <button className={"blueBtn"} style={{ marginRight: 14, width: 95, height: 30, backgroundColor: '#038EFB', borderRadius: 6, borderWidth: 0, color: 'white' }} onClick={this.downloadClick.bind(this, this.props.item)}>Download</button>}

                </div>

            </div>
        )
    }
}
export default Movie;
